import(/* webpackMode: "eager", webpackExports: ["PageForm"] */ "/app/apps/webapp/src/modules/auth/login/ui/page-form.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.28_@babel+core@7.27.1_@opentelemetry+api@1.9.0_@playwright+test@1.52.0_react-dom@18_nbwjbru2aecwrjrmcj23wnys6m/node_modules/next/dist/client/image-component.js");
